import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

const panelRoute = () => ({
  path: ":panelId",
  component: null,
  childRoutes: [],
});

export default store => ({
  path: ":templateId",
  component: withAsyncRouteLoading(() =>
    import(/* webpackChunkName: "transcripts-template" */ "./components").then(
      m => m.default
    )
  ),
  childRoutes: [panelRoute()],
});
